import React from 'react';
import Link from 'next/link';
import { routes } from 'env/routes';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
import withCustomComponent from 'ui/components/withCustomComponent';
import { CoworkerAvatar } from 'ui/components/CoworkerAvatar';
import { CoursesPageCommentsFormField } from './CoursesPageCommentsFormField';

export const CoursesPageCommentsForm = withCustomComponent('CoursesPageCommentsForm')(
  inject(
    'appStore',
    'authStore',
    'coursesStore'
  )(
    withRouter(
      observer(
        ({
          authStore,
          router,
          appStore,
          coursesStore,
          componentName
        }) => {
          const { t } = useTranslation();
          const { newComment } = coursesStore;
          const course = coursesStore.coursePage.Course;
          const { isLoggedIn, customer } = authStore;

          return (
            <>
              {course.AllowComments && (
                <div
                  data-component-name={componentName}
                  className="comments-form"
                >
                  {!isLoggedIn && (
                    <Link
                      href={{
                        pathname: routes.login,
                        query: {
                          returnurl: encodeURIComponent(
                            routes.course_by_id(course)
                          ),
                        },
                      }}
                    >
                      <a className="btn btn-xs btn-outline mt-24">
                        {t('Sign in or join to post new comments')}
                      </a>
                    </Link>
                  )}
                  {isLoggedIn && (
                    <div className="d-flex align-items-center">
                      <div className="pr-8">
                        <CoworkerAvatar
                          size={80}
                          link
                          imgClassName={'avatar avatar--40'}
                          coworker_id={customer.Id}
                        />
                      </div>

                      <CoursesPageCommentsFormField newComment={newComment}/>
                    </div>
                  )}
                </div>
              )}
            </>
          );
        }
      )
    )
  )
);
